<div mat-dialog-title>
  Herinnering versturen
  <button [mat-dialog-close]="false" class="mat-black" mat-flat-button>
    <mat-icon>close</mat-icon>
    Sluiten
  </button>
</div>
<div mat-dialog-content>
  <mat-form-field style="width:100%;">
    <mat-label>Herinnering notitie (optioneel)</mat-label>
    <textarea [formControl]="form.controls.note" matInput maxlength="2000" rows="3"></textarea>
    <mat-hint align="end">
      {{ form.controls.note.value.length }} / 2000
    </mat-hint>
  </mat-form-field>

</div>
<mat-dialog-actions>
  <button (click)="submit(form.value)" [disabled]="!form.valid" color="primary" mat-flat-button>OPSLAAN</button>
</mat-dialog-actions>
<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
